<script>
  // packages
  import { intcomma } from 'journalize';
  import { __ } from '../../../utils/i18n';

  // component
  import Tooltip from './Tooltip.svelte';

  // utils
  import { getContrast } from '../../../utils/get-contrast';

  /** @type {number} */
  export let x;
  /** @type {number} */
  export let y;

  /** @type {string} */
  export let title;
  /** @type {number} */
  export let total_cases;
  /** @type {number} */
  export let total_cases_hotspots;
  /** @type {number | null} */
  export let per_10k;
  /** @type {number | null} */
  export let per_10k_hotspots;
  /** @type {string} */
  export let totals_color;
  /** @type {string} */
  export let hotspots_color;
  /** @type {boolean} */
  export let no_data = false;
  export let includeTimeseries = true;
</script>

<Tooltip {x} {y}>
  <div class="font-sans-serif">
    <p class="tooltip-title font-weight-bold font-sans-serif m-0 text-center">
      {title}
    </p>
    {#if no_data}
      <p class="text-xs m-0 font-sans-serif">No data available</p>
    {:else}
      <table class="text-xs mx-auto border-collapse">
        <thead>
          <tr>
            <th
              class="font-weight-medium p-1.5 text-left border-bottom"
              scope="col">{__('Cases')}</th
            >
            {#if includeTimeseries == true}
            <th
              class="font-weight-medium p-1.5 text-right border-bottom"
              scope="col">{__('Last 14 days')}</th
            >
            {/if}
            <th
              class="font-weight-medium p-1.5 text-right border-bottom"
              scope="col"
            >
              {__('Cumulative')}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="p-1.5 border-bottom">Per 10K</td>
            {#if includeTimeseries == true}
              <td class="p-1.5 border-bottom text-right"
                ><span
                  class="pill"
                  style="color: {getContrast(
                    hotspots_color
                  )}; background-color: {hotspots_color}; font-weight: 500;"
                  >{per_10k_hotspots != null
                    ? intcomma(per_10k_hotspots)
                    : '-'}</span
                ></td
              >
            {/if}
            <td class="p-1.5 border-bottom text-right"
              ><span
                class="pill"
                style="color: {getContrast(
                  totals_color
                )}; background-color: {totals_color}; font-weight: 500;"
                >{per_10k != null ? intcomma(per_10k) : '-'}</span
              ></td
            >
          </tr>
          <tr>
            <td class="p-1.5">Total</td>
            {#if includeTimeseries == true}
              <td class="p-1.5 text-right"
              ><span class="pill">{intcomma(total_cases_hotspots)}</span></td
            >
            {/if}
            <td class="p-1.5 text-right"
              ><span class="pill">{intcomma(total_cases)}</span></td
            >
          </tr>
        </tbody>
      </table>
    {/if}
  </div>
</Tooltip>

<style>
  .pill {
    border-radius: 2px;
    padding: 2px;
  }
</style>
